import { Link } from "react-router-dom";
import { comics } from "@/mocks/comics";

const latestIds = [2, 4, 8, 1, 14, 16, 11, 7, 9];
const latest = latestIds.map((id) => comics.find((c) => c.id === id)!).filter(Boolean);

export default function LatestSection() {
  return (
    <section className="max-w-7xl mx-auto px-4 md:px-8 py-14 md:py-20">
      <div className="flex items-end justify-between gap-4 mb-8">
        <div>
          <p className="text-sm font-medium text-primary-600 tracking-widest">UPDATES</p>
          <h2 className="mt-2 font-heading font-bold text-2xl md:text-3xl text-foreground-950">
            最新更新
          </h2>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {latest.map((comic, idx) => (
          <Link
            key={comic.id}
            to={`/detail/${comic.id}`}
            className="group flex items-center gap-4 rounded-xl bg-background-100 border border-background-200/70 p-3 hover:border-primary-200 transition-colors"
          >
            <img
              src={comic.cover}
              alt={`${comic.title}最新更新封面`}
              title={`${comic.title} ${comic.genre}漫画`}
              className="w-16 h-20 md:w-20 md:h-24 rounded-lg object-cover object-top"
            />
            <div className="flex-1 min-w-0">
              <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-900 group-hover:text-primary-700 line-clamp-1">
                {comic.title}
              </h3>
              <p className="mt-1 text-xs text-foreground-500 line-clamp-2">{comic.intro}</p>
              <div className="mt-2 flex items-center gap-3 text-xs">
                <span className="px-2 py-0.5 rounded-full bg-primary-100 text-primary-700">{comic.genre}</span>
                <span className="text-primary-600 flex items-center gap-1">
                  <i className="ri-fire-line"></i>
                  更新至 {comic.chapters} 话
                </span>
              </div>
            </div>
            <span className="text-xs text-foreground-400 whitespace-nowrap">
              <i className="ri-time-line mr-1"></i>
              {comic.update}
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}